import { Input } from '@angular/core'
import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-svg-toggle',
  templateUrl: './svg-toggle.component.svg',
  styleUrls: ['./svg-toggle.component.scss']
})
export class SvgToggleComponent implements OnInit {
  colorPurple:string = "#6016AA"
  colorYellow:string = "#FBEB00"
  colorYellowDisabled:string = "#fdf9be"
  colorPurpleDisabled:string = "#d6c3e9"
  colorWhite:string = "#FFF"
  positionLeft:string = "14"
  positionRight:string = "37"
  
  fillColorButton:string 
  fillColorBack:string
  fillColorBackGround:string
  strokeColorBack:string 
  positionCxButton:string

  @Input() index:string
  @Input() positionStart:string
  @Input() positionStop:string
  @Input() disableToggle;
  ngOnInit() {
    console.log("%c POSITION TOGGLE => start : "+ this.positionStart+' // stop : '+ this.positionStop, 'color:green;')
    this.disableToggle = this.disableToggle == 'TRUE'
    if (this.disableToggle) {
      if(this.positionStart == "TRUE"){
        this.positionCxButton = this.positionRight 
        this.fillColorButton = this.colorYellowDisabled
        this.fillColorBack = this.colorPurpleDisabled
        this.fillColorBackGround =  this.colorPurpleDisabled
  
      }else if(this.positionStart == "FALSE"){
        this.positionCxButton = this.positionLeft 
        this.fillColorButton = this.colorPurpleDisabled
        this.fillColorBack = this.colorWhite
        this.fillColorBackGround =  this.colorPurpleDisabled
      }
    } else if(this.positionStart == "TRUE"){
      this.positionCxButton = this.positionRight
      this.fillColorButton = this.colorYellow
      this.fillColorBack = this.colorPurple
      this.fillColorBackGround = this.colorPurple

    }else if(this.positionStart == "FALSE"){
      this.positionCxButton = this.positionLeft
      this.fillColorButton = this.colorPurple
      this.fillColorBack = this.colorWhite
      this.fillColorBackGround = this.colorPurple
  
    }else if(this.positionStart == "STOP"){
      if(this.positionStop == 'TRUE'){
        this.positionCxButton = this.positionRight 
        this.fillColorButton = this.colorYellowDisabled
        this.fillColorBack = this.colorPurpleDisabled
        this.fillColorBackGround =  this.colorPurpleDisabled
      }else{
        this.positionCxButton = this.positionLeft 
        this.fillColorButton = this.colorPurpleDisabled
        this.fillColorBack = this.colorWhite
        this.fillColorBackGround =  this.colorPurpleDisabled
      }
    }
}
  changePosition() {
    if (!this.disableToggle) {
      if(this.positionStart !== "STOP"){
        if(this.positionStart == "FALSE"){ //FALSE TO TRUE
            this.toggleOn()
        }else{  //TRUE TO FALSE
            this.toggleOff()
        }
      }
    }
    }

    toggleOn() {
console.log(this.disableToggle)
        if (!this.disableToggle) {
            this.positionStart = "TRUE"
            this.positionCxButton = this.positionRight
            this.fillColorButton = this.colorYellow
            this.fillColorBack = this.colorPurple
        }
    }
    toggleOff() {
        if (!this.disableToggle) {
            this.positionStart = "FALSE"
            this.positionCxButton = this.positionLeft
            this.fillColorButton = this.colorPurple
            this.fillColorBack = this.colorWhite
        }
    }
}
